import { render, staticRenderFns } from "./FBAType.vue?vue&type=template&id=4930ffce&scoped=true"
import script from "./FBAType.vue?vue&type=script&lang=js"
export * from "./FBAType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930ffce",
  null
  
)

export default component.exports